import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Grid, Segment, Button, Divider, Icon, Input, Message } from 'semantic-ui-react';
class ProcessNewAccountRequestModal extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props.item, isActive: true, message: '',messageToUser: '', start: null, end: null };
        this.onFieldChange = this.onFieldChange.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onAccept = this.onAccept.bind(this);
        this.onDecline = this.onDecline.bind(this);        
    }
       
    onReset(e) {
        this.setState({ isActive: true, message: '',messageToUser: '', start: null, end: null });
    }
    
    onFieldChange(e, { name, value }) {        
        this.setState({ [name]: value });        
    }

    onAccept(e)
    {   
        const { onVerificationProcessed, item } = this.props;
        item.accepted = true;
        item.messageToUser = null;
        onVerificationProcessed(e,item);
    }

    onDecline(e)
    {        
        const { onVerificationProcessed, item } = this.props;        
        item.accepted = false;
        item.messageToUser = this.state.messageToUser;
        onVerificationProcessed(e,item);
    }

    render() {       
        const { open, onClose, item, error } = this.props;
        const {messageToUser} = this.state;

        let errorMessage;
        if (error) {
            const content = Array.isArray(error) ? error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : error;
            errorMessage = (<Message error content={content} />);
            //errorMessage = (<Message error header="Verification Failed" content={content} />);
        }

        return (
            
            <Modal open={open} className="processNewAccountRequest" onClose={onClose} closeIcon>
                <Modal.Header>New Account Request Details</Modal.Header>
                {(item && item != null ?
                    <Modal.Content>
                        <Grid columns="2">                        
                            <Grid.Column>
                                <h3>Policy Number</h3>
                                <span>{item.policyNumber}</span>
                            </Grid.Column>
                            <Grid.Column>
                                <h3>Policyholder</h3>
                                <span>{item.policyHolder}</span>
                            </Grid.Column>

                            <Grid.Column>
                                <h3>Drivers License Number</h3>
                                <span>{item.driversLicenseNumber}</span>
                            </Grid.Column>
                            <Grid.Column>
                                <h3>ZIP Code</h3>
                                <span>{item.zip}</span>
                            </Grid.Column>

                            <Grid.Column>
                                <h3>Date of Birth</h3>
                                <span>{item.dateOfBirth}</span>
                            </Grid.Column>
                            <Grid.Column>
                                <h3>Last 4 of SSN/FEIN</h3>
                                <span>{item.employeeIdentificationNumber}</span>
                            </Grid.Column>

                            <Grid.Column>
                                <h3>Email</h3>
                                <span>{item.staffVerificationEmail}</span>
                            </Grid.Column>
                            <Grid.Column>
                                <h3>Phone Number</h3>
                                <span>{item.staffVerificationPhoneNumber}</span>
                            </Grid.Column>                            
                            {(error ?
                            <Grid.Column width={16}>                                
                                <h3>Message to Requestor</h3>
                                <Input fluid name="messageToUser" value={messageToUser} onChange={this.onFieldChange} placeholder="Only required when rejecting request. Do not include any personal information." />                                                          
                            </Grid.Column>: null)}
                        </Grid>

                                         {errorMessage}     

                        <Segment padded>                        
                            <Button data={item} primary fluid onClick={this.onAccept}>
                                <Icon name="thumbs up"></Icon>
                                Accept
                            </Button>
                            <Divider horizontal>Or</Divider>
                            <Button data={item} secondary fluid onClick={this.onDecline}>
                                <Icon name="thumbs down"></Icon>
                                Decline
                            </Button>
                        </Segment>

                    </Modal.Content>
                    : null)}
            </Modal>
        );
    }
}

ProcessNewAccountRequestModal.propTypes = {
    open: PropTypes.bool.isRequired,
    item: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onVerificationProcessed: PropTypes.func.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default ProcessNewAccountRequestModal;